import { render, staticRenderFns } from "./ResetByMobile.vue?vue&type=template&id=066354eb"
import script from "./ResetByMobile.vue?vue&type=script&lang=js"
export * from "./ResetByMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports